import { NgModule } from '@angular/core';
import { SafeCommentPipe } from './safe-comment.pipe';
import { ImagePathPipe } from './image-path.pipe';
import { RemoveUnderscorPipe } from './remove-underscor.pipe';
import { PositivePipe } from './positive.pipe';
import { CheckPercentagePipe } from './check-percentage.pipe';
import { IndainNumberPipe } from './indain-number.pipe';

@NgModule({
    declarations: [
        SafeCommentPipe,
        RemoveUnderscorPipe,
        PositivePipe,
        CheckPercentagePipe,
        IndainNumberPipe,
        ImagePathPipe
    ],
    exports     : [
        SafeCommentPipe,
        RemoveUnderscorPipe,
        PositivePipe,
        CheckPercentagePipe,
        IndainNumberPipe,
        ImagePathPipe
    ]
})
export class AllPipeModule
{
}